var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCaracteristicas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.392,
    height: 19.514,
    viewBox: "0 0 24.392 19.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002e6b;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4336",
    "data-name": "Group 4336",
    transform: "translate(559 4900.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    className: "cls-1",
    d: "M24.392,5.853H22.507L20.245,0H4.147L1.885,5.853H0V7.317H1.32L0,10.731v7.318a1.464,1.464,0,0,0,1.464,1.464H4.147A1.464,1.464,0,0,0,5.61,18.049v-.977H18.782v.977a1.464,1.464,0,0,0,1.463,1.464h2.683a1.464,1.464,0,0,0,1.464-1.464V10.731L23.072,7.317h1.319ZM5.15,1.463H19.242l1.7,4.39H3.454Zm-1,16.586H1.464V11L2.889,7.317H21.5L22.928,11v7.045H20.245v-2.44H4.147Z",
    transform: "translate(-559 -4900)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3651",
    "data-name": "Rectangle 3651",
    className: "cls-1",
    width: 8.719,
    height: 2.766,
    transform: "translate(-551.163 -4890.043)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaracteristicas);
export default __webpack_public_path__ + "static/media/Icon_Caracteristicas.f3d362f57700a4d7c42d153d959aef9d.svg";
export { ForwardRef as ReactComponent };